import { useState } from "react";
import { formatDateForInput, getThisMonthDates } from "../utils/dateRange";
import { formatDate } from "../utils/formatters";

const getStartOfWeek = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff));
};

const getEndOfWeek = (date) => {
  const start = getStartOfWeek(date);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  return end;
};

export const useDateRangeFilter = () => {
  const defaults = getThisMonthDates();
  const [dateFrom, setDateFrom] = useState(defaults.from);
  const [dateTo, setDateTo] = useState(defaults.to);
  const [selectedPreset, setSelectedPreset] = useState("thisMonth");
  const [applied, setApplied] = useState({ from: defaults.from, to: defaults.to });

  const handlePresetSelection = (preset) => {
    const today = new Date();
    let from, to;

    switch (preset) {
      case "thisWeek":
        from = getStartOfWeek(today);
        to = getEndOfWeek(today);
        break;

      case "lastWeek": {
        const lastWeek = new Date(today);
        lastWeek.setDate(today.getDate() - 7);
        from = getStartOfWeek(lastWeek);
        to = getEndOfWeek(lastWeek);
        break;
      }

      case "thisMonth":
        from = new Date(today.getFullYear(), today.getMonth(), 1);
        to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;

      case "lastMonth":
        from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        to = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

      case "thisYear":
        from = new Date(today.getFullYear(), 0, 1);
        to = new Date(today.getFullYear(), 11, 31);
        break;

      case "last30Days":
        from = new Date(today);
        from.setDate(today.getDate() - 30);
        to = today;
        break;

      case "allTime":
        setDateFrom("");
        setDateTo("");
        setSelectedPreset("allTime");
        setApplied({ from: "", to: "" });
        return;

      default:
        return;
    }

    const formattedFrom = formatDateForInput(from);
    const formattedTo = formatDateForInput(to);

    setDateFrom(formattedFrom);
    setDateTo(formattedTo);
    setSelectedPreset(preset);
    setApplied({ from: formattedFrom, to: formattedTo });
  };

  const handleApply = () => {
    setSelectedPreset("");
    setApplied({ from: dateFrom, to: dateTo });
  };

  const handleClearDates = () => {
    setDateFrom("");
    setDateTo("");
    setSelectedPreset("");
    setApplied({ from: "", to: "" });
  };

  return {
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    selectedPreset,
    setSelectedPreset,
    appliedDateFrom: applied.from,
    appliedDateTo: applied.to,
    handlePresetSelection,
    handleApply,
    handleClearDates,
    formatDate,
  };
};
